import React from 'react';
import {
    Grid,
    Button,
    Box
} from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const MaternalDeathForm = (props) => {
    const { values, errors, touched, handleBlur, setFieldValue, isSubmitting, maternalDeathMinDate } = props;
    return (
        <Box>
            <Grid container spacing={2} sx={{ alignItems: "flex-start" }}>
                {/* Date of Death */}
                <Grid size={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Date of Death *"
                            format="DD-MM-YYYY"
                            minDate={dayjs(maternalDeathMinDate)}
                            maxDate={dayjs()}
                            value={values.date_of_death ? dayjs(values.date_of_death) : null}
                            onChange={(value) => {
                                setFieldValue('date_of_death', value ? value.format('YYYY-MM-DD') : null);
                            }}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    autoComplete: "off",
                                    error: touched.date_of_death && Boolean(errors.date_of_death),
                                    helperText: touched.date_of_death && errors.date_of_death,
                                    onBlur: handleBlur,
                                    name: "date_of_death",
                                    onDrop: (e) => {
                                        e.preventDefault();
                                        return false;
                                    },
                                },
                            }}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* Submit Button */}
                <Grid size={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default MaternalDeathForm;
